import { FC } from 'react';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';

import { Box, Button, Stack, TextField, styled } from '@mui/material';

import { ProductDto, ChargebeeSubscriptionDto } from '../types';

import styles from '../styles.module.scss';

const ViewTokenUsageButton = styled(Button)`
  background-color: transparent;
  color: #00f5ba;
  height: 28px;
  padding: 0px 12px;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #00f5ba;
  font-weight: 500;
  font-size: 11px;
  line-height: 12px;
  letter-spacing: 0.04em;
  text-transform: none;
  white-space: nowrap;
  min-width: auto;
  &:hover {
    background-color: #00f5ba;
    border-color: #00f5ba;
    color: #272727;
  }
`;

type SubscriptionDetailsSDKProps = {
  subscriptionDetails: ProductDto;
  chargebeeSubscription?: ChargebeeSubscriptionDto | null;
  tokensLeft?: number;
};

export const SubscriptionDetailsSDK: FC<SubscriptionDetailsSDKProps> = ({
  subscriptionDetails,
  chargebeeSubscription,
  tokensLeft,
}) => {
  const navigate = useNavigate();
  const renewalDate = chargebeeSubscription?.nextBillingAt ?? chargebeeSubscription?.currentTermEnd;

  return (
    <Box component="div" display="flex" flexDirection="column" gap="6px" height="100%">
      <Box component="div" display="flex" justifyContent="space-between" alignItems="center">
        <p style={{ fontWeight: '600' }}>SDK subscription</p>
        <ViewTokenUsageButton onClick={() => navigate('/administration/usage')}>View token usage</ViewTokenUsageButton>
      </Box>
      <Box component="div" display="flex" flex="1 1 0" bgcolor="#272727" borderRadius="4px">
        <Stack spacing={1.8} padding="24px 20px 12px 10px" width="100%">
          <TextField
            className={styles['text-field-input']}
            InputProps={{ disabled: true }}
            InputLabelProps={{ shrink: true }}
            label="Subscription type"
            value={subscriptionDetails.billingType}
          />
          <Stack direction="row" spacing={1.8}>
            {renewalDate && (
              <TextField
                className={styles['text-field-input']}
                sx={{ flex: 1 }}
                InputProps={{ disabled: true }}
                InputLabelProps={{ shrink: true }}
                label="Billing renews"
                value={dayjs(renewalDate).format('DD/MM/YYYY')}
              />
            )}
            {subscriptionDetails.expiresAt && (
              <TextField
                className={styles['text-field-input']}
                sx={{ flex: 1 }}
                InputProps={{ disabled: true }}
                InputLabelProps={{ shrink: true }}
                label="Access until"
                value={dayjs(subscriptionDetails.expiresAt).format('DD/MM/YYYY')}
              />
            )}
          </Stack>
          <Stack flexDirection="row" justifyContent="space-between">
            <TextField
              className={styles['text-field-input']}
              InputProps={{ disabled: true }}
              InputLabelProps={{ shrink: true }}
              label="Seats"
              value={`${subscriptionDetails.activeSeats || 0} / ${subscriptionDetails.maxSeats || 0}`}
            />
            {tokensLeft !== undefined && (
              <TextField
                className={styles['text-field-input']}
                InputProps={{ disabled: true }}
                InputLabelProps={{ shrink: true }}
                label="Tokens"
                value={tokensLeft.toFixed(2)}
              />
            )}
          </Stack>
          <Stack flexDirection="row" justifyContent="space-between">
            <TextField
              className={styles['text-field-input']}
              InputProps={{ disabled: true }}
              InputLabelProps={{ shrink: true }}
              label="GPUs per job"
              value={`${subscriptionDetails.sdkMaxGpuCountPerTask ?? '-'}`}
            />
            <TextField
              className={styles['text-field-input']}
              InputProps={{ disabled: true }}
              InputLabelProps={{ shrink: true }}
              label="Concurrency"
              value={subscriptionDetails.sdkMaxGpuConcurrency ?? '-'}
            />
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
};
